import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { GRAPHQL_HOST } from 'src/config/config'

/**
 * Inside the Strapi admin Live Preview iframe, the admin posts a `strapiUpdate`
 * message to this window whenever the document is saved. While Preview Mode is
 * active, re-run the current route's data fetching so the latest draft renders
 * without a manual reload.
 */
export const useStrapiPreviewRefresh = () => {
  const router = useRouter()

  useEffect(() => {
    if (!router.isPreview) return undefined

    let strapiOrigin: string | null = null
    try {
      strapiOrigin = GRAPHQL_HOST ? new URL(GRAPHQL_HOST).origin : null
    } catch {
      strapiOrigin = null
    }
    if (!strapiOrigin) return undefined

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== strapiOrigin) return
      if (event.data && event.data.type === 'strapiUpdate') {
        router.replace(router.asPath, undefined, { scroll: false })
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [router, router.isPreview, router.asPath])
}
